import React, { useEffect } from "react";
import "./fare-spectra-school-of-autism.css";
import Header from "../../../../components/header";

//Images
import Home_Background from "../../../../assets/childrin&education_spotlight.webp";
import Blue_Background from "../../../../assets/image_028.jpg";

import { ParallaxProvider } from "react-scroll-parallax";

//AOS
import Aos from "aos";
import "aos/dist/aos.css";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function SpotLight() {

  const handleScrollToNext = () => {
    const nextSection = document.getElementById("next-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <ParallaxProvider>
      <div className="screen-page">
        <Header />
        {/* section 01 */}
        <div style={{ position: "relative" }}>
          <div className="home-page-background">
            <div>
              <img
                src={Home_Background}
                style={{ height: "calc(100vh-120px)", width: "100%", objectFit: "cover" }}
                alt=""
              />
            </div>
          </div>

          {/* <div style={{ marginLeft: "20px" }}>
            <div className="childrin-education-p2-text-box">
              <div>
                <Parallax speed={10}>
                  <h1
                    data-aos="fade-right"
                    className="childrin-education-p2-topic-home"
                  >
                    Fare Spectra <br />
                    School of <br />
                    Autism
                  </h1>
                </Parallax>
              </div>
            </div>
          </div> */}

          {/* White Box */}
          <div className="white-spotlight-box">
            <div className="white-spotlight-box-container">
              {/* <h1>
                Modern <span className="white-spotlight-box-container-h1">& Unique</span>
              </h1> */}
              <div className="screen-pc">
                <h1 className="white-spotlight-box-container-h1-text">
                  Fare Spectra <br />
                  <span className="white-spotlight-box-container-h1">School of <br />
                    Autism</span>
                </h1>
              </div>

              <div className="screen-mobile">
                <p className="white-spotlight-box-container-h1-text">
                Fare Spectra <br />
                  <span className="white-spotlight-box-container-h1">
                    School of <br />
                    Autism
                  </span>
                </p>
              </div>

              {/* Button to scroll to the next section */}
              <div onClick={handleScrollToNext} className="scroll-button">
                <FontAwesomeIcon icon={faArrowDown} style={{ fontSize: "16px" }} />
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "calc(100vh-120px)",
              backgroundColor: "rgba(0, 0, 0, 0.35)",
              zIndex: 0,
            }}
          ></div>

          {/* H Letter Design */}
          <div className="h-banner-container">
            {/* Left Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-left"></div>
            </div>

            {/* Middle Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-design-N">
                <div className="h-left-N"></div>
                <div style={{ height: "350px" }} />
                <div className="h-right-N"></div>
              </div>
            </div>

            {/* Right Section */}
            <div
              className="h-design slider-left-time"
              style={{ animationDelay: "0.4s" }}
            >
              <div className="h-right"></div>
            </div>
          </div>
        </div>

        <div className="childrin-education-p2-contents">
          <div className="childrin-education-p2-content-left">
            <div className="childrin-education-p2-content-left-l">
              <img
                src={Blue_Background}
                alt="Blue Shape"
                data-aos="flip-right"
              />
              {/* <div
                className="childrin-education-p2-content-left-l-content"
                data-aos="fade-in"
                data-aos-delay="1000"
              >
                <p>
                  Under our successful and globally recognized Wonders of
                  Wellbeing (WOW) program, Hirdaramani introduced a new pilot
                  project across two Sri Lankan facilities in 2023 aimed at
                  developing ‘gender enablers’ at leadership level. With the
                  support of the Board, the project also aimed to create and
                  implement a gender inclusive policy for the Group.
                </p>
              </div> */}
            </div>
            <div className="childrin-education-p2-content-left-r"></div>
          </div>
          <div className="childrin-education-p2-content-right">
            <h1 className="childrin-education-p2-content-right-heading">
              Bangladesh:
            </h1>
            <h1 className="childrin-education-p2-content-right-heading-main">
              FARE - Spectra School of Autism
            </h1>
            <div
              className="childrin-education-p2-content-right-contents"
              data-aos="fade-in"
            >
              <p>
                FARE - Foundation for Autism Research and EducationWe are deeply
                committed to the health and wellbeing of all children as part of
                our efforts to uplift lives across communities in the countries
                we operate. 'FARE - Foundation for Autism Research and
                Education' is one of our initiatives towards inclusive education
                led by Hirdaramani Bangladesh in a decade-long partnership. Over
                the years, we have supported the school's maintenance and in
                2023, we embarked on a special project to enhance the students'
                communication skills through a tech platform. The solution
                included the setting up of infrastructure and provision of
                required equipment and software for the children’s use at the
                facility.
              </p>
              <p>
                The institute is maintained with funding from Hirdaramani and 75
                students are empowered with better access to technology.
              </p>
            </div>
          </div>
        </div>
      </div>
    </ParallaxProvider>
  );
}

export default SpotLight;
